module.exports = __webpack_public_path__ + "static/dropdown-rectangle-497cd3bef3f9ee9708191af1faf668b6.png";